'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _downshift = require('downshift');

var _downshift2 = _interopRequireDefault(_downshift);

var _colors = require('../styles/colors');

var _typography = require('../styles/typography');

var _TextField = require('./TextField');

var _TextField2 = _interopRequireDefault(_TextField);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var TypeAhead = function (_Component) {
    _inherits(TypeAhead, _Component);

    function TypeAhead(props) {
        _classCallCheck(this, TypeAhead);

        var _this = _possibleConstructorReturn(this, (TypeAhead.__proto__ || Object.getPrototypeOf(TypeAhead)).call(this, props));

        var value = _this.props.value;

        _this.state = {
            inputValue: value
        };
        _this.getOnKeyDown = _this.getOnKeyDown.bind(_this);
        return _this;
    }

    _createClass(TypeAhead, [{
        key: 'getOnKeyDown',
        value: function getOnKeyDown(highlightedIndex, inputValue, isOpen) {
            var _props = this.props,
                items = _props.items,
                onKeyDown = _props.onKeyDown;

            if (highlightedIndex === null) {
                return onKeyDown;
            }
            var itemsLength = items.filter(function (i) {
                return i.toLowerCase().includes(inputValue.toLowerCase());
            });
            if (isOpen && itemsLength.length > 0) {
                return undefined;
            }

            return onKeyDown;
        }
    }, {
        key: 'renderInput',
        value: function renderInput(_ref) {
            var _this2 = this;

            var getInputProps = _ref.getInputProps,
                getItemProps = _ref.getItemProps,
                isOpen = _ref.isOpen,
                inputValue = _ref.inputValue,
                highlightedIndex = _ref.highlightedIndex,
                openMenu = _ref.openMenu,
                selectedItem = _ref.selectedItem;
            var _props2 = this.props,
                dropdownBackground = _props2.dropdownBackground,
                dropdownHighlight = _props2.dropdownHighlight,
                dropdownStyle = _props2.dropdownStyle,
                items = _props2.items,
                onKeyDown = _props2.onKeyDown,
                textFieldStyle = _props2.textFieldStyle;


            return _react2.default.createElement(
                'div',
                { style: { width: textFieldStyle.width, position: 'absolute' } },
                _react2.default.createElement(_TextField2.default, _extends({}, getInputProps({
                    isOpen: isOpen,
                    onFocus: function onFocus() {
                        _this2.setState({ inputValue: '' });
                        return openMenu();
                    },
                    onKeyDown: this.getOnKeyDown(highlightedIndex, inputValue, isOpen),
                    value: inputValue
                }), {
                    style: _extends({}, textFieldStyle)
                })),
                isOpen ? _react2.default.createElement(
                    'div',
                    {
                        style: {
                            width: 200,
                            position: 'fixed',
                            maxHeight: 350,
                            overflowY: 'scroll',
                            overflowX: 'hidden'
                        }
                    },
                    items.filter(function (i) {
                        return !inputValue || i.toLowerCase().includes(inputValue.toLowerCase());
                    }).map(function (item, index) {
                        return _react2.default.createElement(
                            'div',
                            getItemProps({
                                key: item,
                                index: index,
                                item: item,
                                style: _extends({
                                    backgroundColor: highlightedIndex === index ? dropdownHighlight : dropdownBackground
                                }, dropdownStyle)
                            }),
                            item
                        );
                    })
                ) : null
            );
        }
    }, {
        key: 'render',
        value: function render() {
            var _this3 = this;

            var _props3 = this.props,
                update = _props3.update,
                value = _props3.value;

            return _react2.default.createElement(
                _downshift2.default,
                {
                    onStateChange: function onStateChange(_ref2) {
                        var inputValue = _ref2.inputValue;

                        return inputValue && _this3.setState({ inputValue: inputValue }, update(inputValue));
                    },
                    selectedItem: this.state.inputValue,
                    defaultInputValue: value
                },
                function (props) {
                    return _this3.renderInput(props);
                }
            );
        }
    }]);

    return TypeAhead;
}(_react.Component);

TypeAhead.propTypes = {
    dropdownBackground: _propTypes2.default.string,
    dropdownHighlight: _propTypes2.default.string,
    dropdownStyle: _propTypes2.default.object,
    items: _propTypes2.default.arrayOf(_propTypes2.default.string),
    onKeyDown: _propTypes2.default.func,
    textFieldStyle: _propTypes2.default.object,
    update: _propTypes2.default.func,
    value: _propTypes2.default.string
};

TypeAhead.defaultProps = {
    dropdownBackground: _colors.slate,
    dropdownHighlight: _colors.ash,
    dropdownStyle: _extends({}, _typography.text, _typography.light, {
        alignItems: 'center',
        border: '1px solid ' + _colors.steel,
        borderTop: 'none',
        color: 'white',
        display: 'block',
        height: 35,
        paddingLeft: 15,
        // Have to add padding-top to get text vertically centered.
        // Display: flex will not work with textOverflow: Ellipsis,
        // adjusting line-height causes weird rendering
        paddingTop: 9,
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap'
    }),
    items: ['apple', 'orange', 'banana', 'grape', 'tomato'],
    onKeyDown: function onKeyDown() {
        return null;
    },
    textFieldStyle: {
        backgroundColor: _colors.slate,
        borderColor: _colors.silver,
        color: 'white',
        focus: { borderColor: _colors.silver },
        fontSize: 14,
        inputStyle: {
            padding: '3px 15px 0 0'
        },
        width: 400
    },
    update: function update(value) {
        return console.log(value);
    },
    value: 'test'
};

exports.default = TypeAhead;
//# sourceMappingURL=TypeAhead.js.map